import { createAction, createAsyncAction } from 'typesafe-actions';
import { MerchantLinkState, ProgramEntry } from './types';

export const comoLinkActions = {
  fetchState: createAsyncAction('@comoLink/fetchState', '@comoLink/fetchState/success', '@comoLink/fetchState/error')<
    ProgramEntry,
    ProgramEntry & { merchants: MerchantLinkState[] },
    ProgramEntry
  >(),
  // No success action: the magic URL stays inside the saga so redux-logger never records it.
  // User-initiated reload of the state; unlike fetchState.request it is not deduplicated per entry.
  retryState: createAction('@comoLink/retryState', action => (payload: ProgramEntry) => action(payload)),
  requestMagicLink: createAction(
    '@comoLink/requestMagicLink',
    action => (payload: ProgramEntry & { merchantSequenceKey: string }) => action(payload)
  ),
  handoffFailed: createAction(
    '@comoLink/handoffFailed',
    action => (payload: ProgramEntry & { code: string; retryAt?: number }) => action(payload)
  ),
  handoffCancelled: createAction('@comoLink/handoffCancelled', action => (payload: ProgramEntry) => action(payload)),
  programOpenRequested: createAction(
    '@comoLink/programOpenRequested',
    action => (payload: { programId: string }) => action(payload)
  ),
  reset: createAction('@comoLink/reset')
};
